import { fromJS } from 'immutable'

import { ORG_POST, ORG_UPDATE, ORG_ERROR } from 'actions/create-org'

// Reducer
// ---------------------------------------------------------------------------

export const initialState = fromJS({
  error: false,
  errorData: null,
  loading: false,
  returnData: null,
})

export default function createOrgReducer(state = initialState, action) {
  switch (action.type) {
    case ORG_POST:
      return _postOrg(state)
    case ORG_UPDATE:
      return _updateOrg(state, action.payload)
    case ORG_ERROR:
      return _errorOrg(state, action.payload)
    default:
      return state
  }
}

const _postOrg = state => {
  return state.update('loading', () => true)
}

const _updateOrg = (state, payload) => {
  return state
    .set('returnData', fromJS(payload.data))
    .update('loading', () => false)
    .update('error', () => false)
    .update('errorData', () => null)
}

const _errorOrg = (state, payload) => {
  return state
    .set('error', payload.error)
    .set('errorData', fromJS(payload.data))
    .update('loading', () => false)
}
